// extracted by mini-css-extract-plugin
module.exports = {"img":"_1iJql0VKnkhP5_iILOqzf9"};